import { environment } from '../../environments/environment';
import { SportId } from './enums/sport-id.enum';

/**
 * Padel, Tennis, and other court-based sports use "Court(s)" wording in TMS.
 * Table Tennis (sport_id 1) uses "Table(s)".
 */
export function isCourtBasedSport(sportId: number | null | undefined): boolean {
  const n = Number(sportId);
  if (!Number.isFinite(n)) {
    return false;
  }
  return n === SportId.Padel || n === SportId.Tennis || n === SportId.Badminton;
}

/** `sport_id` from the active environment file (build-time tenant config). */
export function getEnvSportId(): number {
  const n = Number(environment?.sport_id);
  return Number.isFinite(n) ? n : SportId.TableTennis;
}

/**
 * Same as `isCourtBasedSport(environment.sport_id)` — use when the tenant
 * sport is always defined by the env file (typical SPA).
 */
export function isCourtBasedSportEnv(): boolean {
  return isCourtBasedSport(getEnvSportId());
}

/** Short display name for event cards / tags (not i18n — add keys later if needed). */
export function getSportDisplayName(sportId: number | null | undefined): string {
  const n = Number(sportId);
  if (n === SportId.TableTennis) {
    return 'Table Tennis';
  }
  if (n === SportId.Padel) {
    return 'Padel';
  }
  if (n === SportId.Tennis) {
    return 'Tennis';
  }
  if (n === SportId.Badminton) {
    return 'Badminton';
  }
  return 'Padel';
}

export function getSportDisplayNameFromEnv(): string {
  return getSportDisplayName(getEnvSportId());
}

const SURFACE_LABEL_MAP: Record<number, string> = {
  [SportId.TableTennis]: 'Table',
  [SportId.Padel]: 'Court',
  [SportId.Tennis]: 'Court',
  [SportId.Badminton]: 'Court',
};
const DEFAULT_SURFACE_LABEL = 'Table';

/** Returns the surface label ("Court", "Table", etc.) for the given sport. */
export function getSurfaceLabel(sportId: number | null | undefined): string {
  const n = Number(sportId);
  return SURFACE_LABEL_MAP[n] ?? DEFAULT_SURFACE_LABEL;
}

export function getSurfaceLabelFromEnv(): string {
  return getSurfaceLabel(getEnvSportId());
}

const SERVICE_ICON_MAP: Record<number, string> = {
  [SportId.Badminton]: 'assets/SvgIcons/mdi_shuttlecock.svg',
  [SportId.TableTennis]: 'assets/ball.png',
  [SportId.Padel]: 'assets/ball.png',
  [SportId.Tennis]: 'assets/ball.png',
};
const DEFAULT_SERVICE_ICON = 'assets/ball.png';

export function getServiceIcon(sportId: number | null | undefined): string {
  const n = Number(sportId);
  return SERVICE_ICON_MAP[n] ?? DEFAULT_SERVICE_ICON;
}